import { useCurrentEntityId } from "hooks/useCurrentEntityId";
import { useToast } from "hooks/useToast";
import { useDeleteClassificationMutation } from "store/apis/classifications";
import { BackendError } from "types/utils/error";
import { ClassificationWarningModal } from "./ClassificationWarningModal";

type DeleteGroupModalProps = {
  isOpen: boolean;
  onClose: () => void;
  groupName: string;
  groupId: string;
};

export const DeleteGroupModal = ({
  isOpen,
  onClose,
  groupName,
  groupId,
}: DeleteGroupModalProps) => {
  const entityId = useCurrentEntityId();
  const { alertToast, successToast } = useToast();
  const [deleteClassification, { isLoading }] =
    useDeleteClassificationMutation();

  const handleConfirm = async () => {
    try {
      await deleteClassification({
        entityId,
        payload: {
          group_id: groupId,
        },
      }).unwrap();

      successToast({ message: `Group "${groupName}" deleted` });
      onClose();
    } catch (error) {
      alertToast(
        { message: (error as BackendError).data?.error?.message },
        error as Error
      );
    }
  };

  return (
    <ClassificationWarningModal
      isOpen={isOpen}
      onClose={onClose}
      onConfirm={handleConfirm}
      title={`Delete ${groupName}`}
      description="Deleting this group will permanently remove all classifications under it and unassign it from all related transactions. Please confirm to continue."
      isLoading={isLoading}
    />
  );
};
